import { cn } from '@/shared/lib/cn';
import { HintIcon } from '@/shared/ui';

/** Сообщение на экранах входа: «аккаунт не найден», лимит попыток и т.п. */
export function AuthNotice({
  text,
  hint,
  tone = 'warning',
}: {
  text: string;
  hint?: string;
  tone?: 'warning' | 'error';
}) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-xl border px-4 py-3 text-sm',
        tone === 'error'
          ? 'border-red-200 bg-red-50 text-red-700'
          : 'border-amber-200 bg-amber-50 text-amber-800'
      )}
    >
      <p className="min-w-0 flex-1">{text}</p>
      {hint ? <HintIcon text={hint} /> : null}
    </div>
  );
}
